import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { environment } from "@environments/environment";

import { Usuario } from "@shared/Entities/Usuario/usuario.entity";

import { EditUserRequest, NewUser, NewUserDTO } from "../Types/new-user";

const { enlineaBackendUrl } = environment;

@Injectable()
export class CanalesRepository {
  constructor(private http: HttpClient) {}

  public createNewUserFiduciary(newUser: NewUser, isUserCanales: boolean = false, isUserAdmin = false): Observable<Usuario> {
    const newUserDTO: NewUserDTO = this.mapFromNewUserToNewUserDTO(newUser);
    const createUserRequest = {
      user: newUserDTO,
      sendEmail: true,
      isUserCanales,
      isUserAdmin,
    };
    return this.http.post<Usuario>(`${enlineaBackendUrl}/api/fiduciary/admin/create-user`, createUserRequest);
  }

  public createNewUser(newUser: NewUser, isUserCanales: boolean = false, isUserAdmin = false): Observable<Usuario> {
    const newUserDTO: NewUserDTO = this.mapFromNewUserToNewUserDTO(newUser);
    const createUserRequest = {
      user: newUserDTO,
      sendEmail: true,
      isUserCanales,
      isUserAdmin,
    };
    return this.http.post<Usuario>(`${enlineaBackendUrl}/api/admin/users`, createUserRequest);
  }

  public editUserFiduciary(updatedUser: NewUser, id: number): Observable<Usuario> {
    const editUserRequest: EditUserRequest = { ...this.mapFromNewUserToNewUserDTO(updatedUser), id };
    return this.http.patch<Usuario>(`${enlineaBackendUrl}/api/fiduciary/admin/edit-user`, editUserRequest);
  }

  public editUser(updatedUser: NewUser, id: number): Observable<Usuario> {
    const editUserRequest: EditUserRequest = { ...this.mapFromNewUserToNewUserDTO(updatedUser), id };
    return this.http.patch<Usuario>(`${enlineaBackendUrl}/api/admin/users`, editUserRequest);
  }

  public lockUser(userGuid: string): Observable<void> {
    return this.http.patch<void>(`${enlineaBackendUrl}/api/admin/users/Credentials/Lock/${userGuid}`, {});
  }

  public unLockUser(userGuid: string): Observable<void> {
    return this.http.patch<void>(`${enlineaBackendUrl}/api/admin/users/Credentials/Unlock/${userGuid}`, {});
  }

  public getUser(userGuid: string): Observable<Usuario> {
    return this.http.get<Usuario>(`${enlineaBackendUrl}/api/Usuarios/${userGuid}`);
  }

  public getUserFiduciary(userGuid: string): Observable<Usuario> {
    return this.http.get<Usuario>(`${enlineaBackendUrl}/api/fiduciaria/FiduciariaUsuarios/${userGuid}`);
  }

  private mapFromNewUserToNewUserDTO({ birthDate, profile, roles, province, identificationType, ...rest }: NewUser): NewUserDTO {
    return {
      ...rest,
      userCode: rest.userCode || "",
      birthDate: birthDate instanceof Date ? birthDate.toISOString() : birthDate,
      profileId: profile.id,
      rolesId: roles.map((role) => role.id),
      provinceId: province.id,
      identificationTypeId: identificationType,
    };
  }
}
